import type { Coordinates } from "$lib/features/_other/coordinates.type";
import type { Cost } from "$lib/features/_other/cost";

export type WifiAccess = 'yes' | 'no' | 'gratis' | 'paid';

export const WIFI_ACCESS_LABELS: Record<WifiAccess, string> = {
    yes: 'Available',
    no: 'No',
    gratis: 'Free',
    paid: 'Paid',
};

export interface SimplePlace {
    wikidataId: string | null;
    coordinates: Coordinates;
    websiteUrl: string | null;
    facebookId: string | null;
    instagramId: string | null;
    unescoId: number | null;
    elevationMeters: number | null;
    inceptionYear: number | null;
    cost: Cost | null;
    founders: string[] | null;
    architects: string[] | null;
    architecturalStyles: string[] | null;
    heritageDesignations: string[] | null;
    exhibitionSize: number | null;
    visitorsPerYear: number | null;
    visitorsPerYearAsOf: number | null;
    facilities: string[] | null;
    accessibilityProperties: string[] | null;
    wifiAccess: WifiAccess | null;
}
